import React from 'react';
import { createMainController } from '../../../services/createMainController';
import { TagsSelector } from '@wix/branding-client-lib';
import { templateTags } from '../../../consts/templateTags';

const rowCount = [3, 4];
const rowCountMobile = [3, 2];

const TagsSelectorController = props => {
  const { updateLogoSelectorTag, t, selectors } = props;
  const screenType = selectors.getScreenType();
  return (
    <TagsSelector
      templateTags={[...templateTags]}
      rowCounts={screenType === 'mobile' ? rowCountMobile : rowCount}
      selectedTags={selectors.getSelectedTags()}
      onTagSelected={updateLogoSelectorTag}
      t={t}
    />
  );
};

TagsSelectorController.defaultProps = {
  extraTags: []
};

export default createMainController(TagsSelectorController);
